import { render, staticRenderFns } from "./project.vue?vue&type=template&id=921bf5fa&"
import script from "./project.vue?vue&type=script&lang=ts&"
export * from "./project.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports